<template>
  <component
    :is="block.property('asyncItems', 'string', null) ? 'tml-loader' : 'div'"
    :loading="loadingAsyncItems"
    text="Loading..."
    :loading-ratio="1 / 6"
  >
    <h4 v-if="block.property('title', 'string')">
      {{ block.property('title', 'string', null, bindingData) }}
    </h4>
    <tml-grid
      :id="camelCase(block.property('title', 'string'))"
      class="mb-0"
      :breakpoints="block.property('breakpoints', 'json')"
      :spacing="block.property('spacing', 'json')"
    >
      <template v-if="!loadingProducts">
        <block-renderer v-for="item in items" :key="item.uid" :block="item" />
      </template>
      <template v-else>
        <tml-ratio v-for="item in items" :key="item.uid" :ratio="1" />
      </template>
    </tml-grid>
  </component>
</template>

<script>
import {camelCase} from 'lodash';
import BlockRenderer from '../../components/BlockRenderer.vue';
import blockMixin from '../blockMixin';
import {formatUrl} from '@teemill/common/helpers';
import {captureException} from '@sentry/vue';

export default {
  name: 'PageBlockGridBlock',

  components: {BlockRenderer},

  mixins: [blockMixin],

  data() {
    return {
      loadingProducts: false,
    };
  },

  computed: {
    items() {
      return [...this.block.filteredItems, ...this.asyncItems];
    },
  },

  mounted() {
    if (
      ['product-triple-gate', 'product-quad-gate'].includes(
        this.block.property('template', 'string', '')
      ) &&
      this.block.page.mode === 'native'
    ) {
      const itemsToFetch = this.block.items
        .map(item => {
          const href = item.property('href', 'string', '');
          if (!href) {
            return null;
          }

          const lastUrlPart = href.split('/').slice(-2)[0];
          if (!lastUrlPart) {
            return null;
          }

          return {item, urlName: lastUrlPart};
        })
        .filter(i => i && i.urlName !== '#');

      if (itemsToFetch.length === 0) {
        return;
      }

      this.loadingProducts = true;

      const division = $store.state.subdomain?.division;

      const requests = itemsToFetch.map(({item, urlName}) =>
        this.axios
          .get(formatUrl(`/omnis/v3/division/${division}/products/${urlName}`))
          .success(data => {
            this.setPropertyIfPresent(item, 'title', data.name);
            this.setPropertyIfPresent(
              item,
              'href',
              `/product/${data.urlName}/`
            );
            this.setPropertyIfPresent(item, 'price', data.price);
            this.setPropertyIfPresent(item, 'salePrice', data.salePrice);
            this.setPropertyIfPresent(
              item,
              'onSale',
              data.salePrice && data.salePrice < data.price
            );
          })
          .catch(error => {
            captureException(error);
            return Promise.resolve();
          })
      );

      Promise.all(requests).then(() => {
        this.loadingProducts = false;
      });
    }
  },

  methods: {
    camelCase,

    setPropertyIfPresent(block, name, value) {
      if (value) {
        block.setProperty(name, value);
      }
    },
  },
};
</script>
